import LogRocket from "logrocket";
import setupLogRocketReact from "logrocket-react";
import * as Sentry from "@sentry/react";

export function initLogRocket() {
  const appId = import.meta.env.VITE_LOGROCKET_APP_ID;

  if (!appId) {
    console.warn("LogRocket App ID not configured. Session replay disabled.");
    return;
  }

  LogRocket.init(appId);
  setupLogRocketReact(LogRocket);

  LogRocket.getSessionURL((sessionURL) => {
    Sentry.configureScope((scope) => {
      scope.setExtra("sessionURL", sessionURL);
    });
  });
}
